// TypingBubble.tsx – Classic 3-dot bouncing "typing…" indicator (like iMessage / ChatGPT).
import React from 'react';

/**
 * Three animated dots that bounce in sequence to indicate the bot is typing.
 * Used as a standalone typing indicator in the chat.
 */
const TypingBubble: React.FC = () => (
    <div className="typing-bubble" aria-label="Bot is typing">
        <span className="typing-dot" />
        <span className="typing-dot" />
        <span className="typing-dot" />
    </div>
);

export default React.memo(TypingBubble);
